import { SeekBarDuringAdBreak } from '@dicetechnology/dice-unity/lib/services/realm/types';
import { BreakStatusContainer, ConnectedBreakStatus, usePlayerContext, usePlayerTimeContext } from '@dicetechnology/doris-ui';
import React, { useContext, useMemo } from 'react';

import { ReceiverContext } from '../contexts';
import { DiceReceiverManager } from '../services';

const resolvePattern = (key: string) => {
    const value = DiceReceiverManager.getInstance().getTranslationFor(key);
    return value !== `__##${key}##__` ? value : undefined;
};

export const AdProgress: React.FC = () => {
    const {
        state: { isPaused, waiting, isPlayingBreak }
    } = usePlayerContext();

    const { live } = usePlayerTimeContext();

    const {
        settings: { enableHideAdUiElements, seekBarDuringAdBreak }
    } = useContext(ReceiverContext);

    const patterns = useMemo(
        () => ({
            labelPattern: resolvePattern('adCountDown') ?? 'Ad %INDEX% of %COUNT% : (%REMAINING%)',
            adCountDownDurationPattern: resolvePattern('adCountDownDurationPattern'),
            adCountDownTimePattern: resolvePattern('adCountDownTimePattern'),
            adCountDownRemainingPattern: resolvePattern('adCountDownRemainingPattern'),
            adCountDownBreakDurationPattern: resolvePattern('adCountDownBreakDurationPattern'),
            adCountDownBreakTimePattern: resolvePattern('adCountDownBreakTimePattern'),
            adCountDownBreakRemainingPattern: resolvePattern('adCountDownBreakRemainingPattern')
        }),
        []
    );

    if (live && enableHideAdUiElements) {
        return null;
    }

    const adSeekBarVisible = isPlayingBreak && !!seekBarDuringAdBreak && seekBarDuringAdBreak !== SeekBarDuringAdBreak.OFF;

    return (
        <BreakStatusContainer isOverlayActive={isPlayingBreak ? adSeekBarVisible || isPaused : isPaused || waiting}>
            <ConnectedBreakStatus {...patterns} />
        </BreakStatusContainer>
    );
};
